import { Dispatch } from 'react';

import {
	ReportingLibraryScreenDimensions,
	ReportingLibraryTabs,
} from 'common/constants/ReportingLibraryConstants';
import { setSelectedReportingTab } from 'common/store/reducer/commonReducer';

import { IReportingTabs } from './api/type-def';

const {
	RECENTLY_VIEWED_TAB,
	FAVORITES_TAB,
	REQUIREMENT_INVENTORY_TAB,
	HORIZON_SCANNING_TAB,
	PRCI_TAB,
	MANAGEMENT_TAB,
	BOARD_TAB,
} = ReportingLibraryTabs;
const {
	SCREEN_WIDTH_1280,
	SCREEN_WIDTH_1024,
	SCREEN_WIDTH_1920,
	SCREEN_WIDTH_1440,
	SCREEN_WIDTH_1536,
	SCREEN_WIDTH_1792,
	SCREEN_WIDTH_2560,
	SCREEN_HEIGHT_864,
	SCREEN_HEIGHT_960,
	SCREEN_HEIGHT_1080,
	SCREEN_HEIGHT_720,
	SCREEN_HEIGHT_768,
	SCREEN_HEIGHT_920,
	SCREEN_HEIGHT_1600,
	SCREEN_HEIGHT_1120,
} = ReportingLibraryScreenDimensions;

export const reportingTabs: IReportingTabs[] = [
	{
		name: RECENTLY_VIEWED_TAB,
		disabled: false,
	},
	{
		name: FAVORITES_TAB,
		disabled: false,
	},
	{
		name: REQUIREMENT_INVENTORY_TAB,
		disabled: false,
	},
	{
		name: HORIZON_SCANNING_TAB,
		disabled: false,
	},
	{
		name: PRCI_TAB,
		disabled: false,
		hideSentenceCase: true,
	},
	{
		name: MANAGEMENT_TAB,
		disabled: true,
	},
	{
		name: BOARD_TAB,
		disabled: true,
	},
];

export const updateTabName = (index: number, updateTab: Dispatch<any>) => {
	let tab = {
		reportingLibraryTabIndex: -1,
		reportingLibraryTabName: '',
	};
	switch (index) {
		case 0:
			tab = {
				reportingLibraryTabIndex: index,
				reportingLibraryTabName: RECENTLY_VIEWED_TAB,
			};
			break;
		case 1:
			tab = {
				reportingLibraryTabIndex: index,
				reportingLibraryTabName: FAVORITES_TAB,
			};
			break;
		case 2:
			tab = {
				reportingLibraryTabIndex: index,
				reportingLibraryTabName: REQUIREMENT_INVENTORY_TAB,
			};
			break;
		case 3:
			tab = {
				reportingLibraryTabIndex: index,
				reportingLibraryTabName: HORIZON_SCANNING_TAB,
			};
			break;
		case 4:
			tab = {
				reportingLibraryTabIndex: index,
				reportingLibraryTabName: PRCI_TAB,
			};
			break;
		case 5:
			tab = {
				reportingLibraryTabIndex: index,
				reportingLibraryTabName: MANAGEMENT_TAB,
			};
			break;
		case 6:
			tab = {
				reportingLibraryTabIndex: index,
				reportingLibraryTabName: BOARD_TAB,
			};
			break;
		default:
			break;
	}
	updateTab(setSelectedReportingTab(tab));
};

type IframeHeightMap = {
	[width: number]: {
		[height: number]: { open: string; closed: string };
	};
};

const IFRAME_HEIGHTS: IframeHeightMap = {
	[SCREEN_WIDTH_1920]: {
		[SCREEN_HEIGHT_1080]: { open: '2639px', closed: '2927px' },
	},
	[SCREEN_WIDTH_1280]: {
		[SCREEN_HEIGHT_720]: { open: '1579px', closed: '1871px' },
	},
	[SCREEN_WIDTH_1792]: {
		[SCREEN_HEIGHT_1120]: { open: '2450px', closed: '2750px' },
	},
	[SCREEN_WIDTH_1440]: {
		[SCREEN_HEIGHT_920]: { open: '1851px', closed: '2140px' },
	},
	[SCREEN_WIDTH_1536]: {
		[SCREEN_HEIGHT_864]: { open: '2000px', closed: '2290px' },
	},
	[SCREEN_WIDTH_2560]: {
		[SCREEN_HEIGHT_1600]: { open: '3689px', closed: '4000px' },
	},
	[SCREEN_WIDTH_1024]: {
		[SCREEN_HEIGHT_960]: { open: '1500px', closed: '1500px' },
		[SCREEN_HEIGHT_768]: { open: '1500px', closed: '1500px' },
	},
};

export const getIframeHeight = (
	screenWidth: number,
	screenHeight: number,
	isAppDrawerOpen: boolean,
): string => {
	const heightMap = IFRAME_HEIGHTS[screenWidth]?.[screenHeight];

	if (heightMap) {
		return isAppDrawerOpen ? heightMap.open : heightMap.closed;
	}

	return '2740px';
};
